import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import firebase from 'firebase';

firebase.initializeApp({
    apiKey: "AIzaSyBiGjZfRPkxntTdZRgbebdVUdRkN88pGsY",
    authDomain: "koval-workshop.firebaseapp.com",
    projectId: "koval-workshop",
    storageBucket: "koval-workshop.appspot.com",
    messagingSenderId: "712400675666",
    appId: "1:712400675666:web:9787137c2e73ddbf28108b"
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
